export default "__VITE_ASSET__39a7c7ce__"